/**
 * FridgeIQ — useAuth hook
 * Checks if the user is signed in and provides sign out.
 */

import { useState, useEffect } from "react";
import { getCurrentUser, signOut } from "aws-amplify/auth";

export function useAuth() {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCurrentUser()
      .then(u => { setUser(u); setLoading(false); })
      .catch(() => { setUser(null); setLoading(false); });
  }, []);

  const handleSignOut = async () => {
    await signOut();
    setUser(null);
  };

  return { user, loading, signOut: handleSignOut };
}
